import { makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { createElement } from 'react';
import typography from '@/theme/typography';
import { SecondaryColors } from '@/utils/constants';
import { encodeSvg } from '@/utils/helpers';

const getLightTheme = (muiTheme: any) => ({
  root: {
    '& $list': {
      '& p a[href]': {
        color: SecondaryColors.dark,
        textDecoration: `underline 1px ${SecondaryColors.dark}`,
        '&:after': {
          backgroundImage: `url(${encodeSvg(
            createElement(ChevronRightIcon, {
              xmlns: 'http://www.w3.org/2000/svg',
              fill: SecondaryColors.dark,
            }),
          )})`,
        },
        '&:hover': {
          color: SecondaryColors.main,
          textDecoration: 'none',

          '&:after': {
            backgroundImage: `url(${encodeSvg(
              createElement(ChevronRightIcon, {
                xmlns: 'http://www.w3.org/2000/svg',
                fill: SecondaryColors.main,
              }),
            )})`,
          },
        },
      },
    },
  },
});
const getDarkTheme = (muiTheme: any) => ({
  root: {
    '& $list': {
      '& p a[href]': {
        color: SecondaryColors.main,
        textDecoration: `underline 1px ${SecondaryColors.main}`,
        '&:after': {
          backgroundImage: `url(${encodeSvg(
            createElement(ChevronRightIcon, {
              xmlns: 'http://www.w3.org/2000/svg',
              fill: SecondaryColors.main,
            }),
          )})`,
        },
        '&:hover': {
          color: SecondaryColors.light,
          textDecoration: 'none',

          '&:after': {
            backgroundImage: `url(${encodeSvg(
              createElement(ChevronRightIcon, {
                xmlns: 'http://www.w3.org/2000/svg',
                fill: SecondaryColors.light,
              }),
            )})`,
          },
        },
      },
    },
  },
});

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': getLightTheme(muiTheme).root,
      '&.dark-theme': getDarkTheme(muiTheme).root,
    },
    wrapper: {
      ...typography.body1,
    },
    headline: {
      '& h1, & h2, & h3, & h4, & h5, & h6': {
        ...typography.h4,
        textTransform: 'capitalize',
        marginBottom: '2px',
      },
    },
    list: {
      '& ul': {
        listStyle: 'none',
        padding: '0',
        margin: '0',
      },

      '& ul > li': {
        margin: '0',

        '& + *': {
          marginTop: '10px',
        },
      },

      '& a[href]': {
        transition: 'color 150ms ease-out',
        whiteSpace: 'nowrap',
        fontSize: '18px',

        '&:after': {
          content: '""',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          display: 'inline-block',
          marginLeft: '2px',
          marginRight: '-4px',
          marginTop: '-2px',
          height: '20px',
          verticalAlign: 'middle',
          width: '20px',
          transition: 'all 150ms ease-in-out',
        },

        '&:hover': {
          textDecoration: 'none',
        },

        [muiTheme.breakpoints.down('sm')]: {
          '&:after': {
            transform: 'translateX(0)',
            opacity: 1,
          },
        },

        '&.wrapSpace': {
          whiteSpace: 'normal',
        },
      },
      '&.wrapSpace': {
        whiteSpace: 'normal',
      },
    },
  }),
  { name: 'GenRelatedLinks' },
);

export default useStyles;
